import { FormGroup, Stack, styled } from "@mui/material";
import Switch from "@mui/material/Switch";
import { ChangeEvent, ReactNode } from "react";
import { Control, Controller, UseFormRegister, UseFormSetValue } from "react-hook-form";

type CustomSwitchWithoutValidationProps = {
  usarValidacaoParaFormulario: false;
};
type CustomSwitchWithValidationProps = {
  usarValidacaoParaFormulario: true;
  /**Nome do atributo que será usado no formulario para realizar as validacoes*/
  name: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  setValue: UseFormSetValue<any>;
};

type CustomSwitchProps = {
  labelDireito?: string;
  labelEsquerdo?: string;
  checked?: boolean | undefined;
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  defaultValue?: boolean;
} & (CustomSwitchWithoutValidationProps | CustomSwitchWithValidationProps);

const CustomSwitch: React.FC<CustomSwitchProps> = (props) => {
  const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#83cf9c",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));

  const renderCustomSwitchComValidacao = (): ReactNode => {
    if (props.usarValidacaoParaFormulario) {
      return (
        <Controller
          name={props.name}
          control={props.control}
          defaultValue={props.defaultValue}
          render={({ field, fieldState }) => (
            <>
              <FormGroup>
                <Stack direction="row" spacing={1} alignItems="center">
                  {props.labelEsquerdo && <span>{props.labelEsquerdo}</span>}
                  <CustomSwitch
                    color="success"
                    checked={field.value}
                    value={field.value}
                    onChange={(event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
                      field.onChange(event);
                      props.setValue(props.name, checked);
                      props.onChange && props.onChange(event, checked);
                    }}
                    inputProps={{ "aria-label": "ant design" }}
                  />
                  {props.labelDireito && <span>{props.labelDireito}</span>}
                </Stack>
              </FormGroup>
            </>
          )}
        />
      );
    }
  };

  const renderCustomSwitchSemValidacao = (): ReactNode => {
    return (
      <FormGroup>
        <Stack direction="row" spacing={1} alignItems="center">
          {props.labelEsquerdo && <span>{props.labelEsquerdo}</span>}
          <CustomSwitch
            color="success"
            checked={props.checked}
            onChange={props.onChange}
            inputProps={{ "aria-label": "ant design" }}
          />
          {props.labelDireito && <span>{props.labelDireito}</span>}
        </Stack>
      </FormGroup>
    );
  };

  return <>{props.usarValidacaoParaFormulario ? renderCustomSwitchComValidacao() : renderCustomSwitchSemValidacao()}</>;
};

export default CustomSwitch;
